module.exports = __webpack_public_path__ + "static/img/20241224_6.44167a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20241224_6.png
// module id = 6VJ4
// module chunks = 0